<template>
  <div class="home-box">
    <el-row style="margin:0;">
      <el-col :span="8" class="list-group-item no-move">
        <div class="first-line">
          <div class="first-head">
            <p><span class="crile bg-color3"></span>今日出勤</p>
            <p><span class="color7">{{ attend.allNowCount }}</span>人</p>
            <p>出勤率<span class="color7"> {{ attend.countRate }}%</span></p>
          </div>
          <div class="first-body">
            <div class="first-body-item">
              <!-- <p class="num color8">{{attend.manageCount}}</p> -->
              <div v-if=" browser != 'IE'" class="num color8">
                <p
                    v-for="(item,index) in numLen1"
                    :key="index"
                    :class="{'number-item': !isNaN(item) }"

                >
                                    <span v-if="!isNaN(item)">
                                    <i ref="numberItem">0123456789</i>
                                    </span>
                  <span v-else>{{ item }}</span>
                </p>
              </div>
              <div v-if=" browser == 'IE'" class="num color8">
                <p style="font-size: 50px;text-shadow:none">{{ attend.manageCount }}</p>
              </div>
              <p class="name">管理人员</p>
            </div>
            <div class="first-body-item">
              <div class="num color8">
                <p
                    v-for="(item,index) in numLen2"
                    v-if=" browser != 'IE'"
                    :key="index"
                    :class="{'number-item': !isNaN(item) }"
                >
                                    <span v-if="!isNaN(item)">
                                    <i ref="numberItem1">0123456789</i>
                                    </span>
                  <span v-else>{{ item }}</span>
                </p>
                <p v-if=" browser == 'IE'" style="font-size: 50px;text-shadow:none">{{ attend.workersCount }}</p>
              </div>
              <p class="name">建筑工人</p>
            </div>
            <div class="first-body-item">
              <div class="num color8">
                <p
                    v-for="(item,index) in numLen3"
                    v-if=" browser != 'IE'"
                    :key="index"
                    :class="{'number-item': !isNaN(item) }"
                >
                                    <span v-if="!isNaN(item)">
                                    <i ref="numberItem2">0123456789</i>
                                    </span>
                  <span v-else>{{ item }}</span>
                </p>
                <p v-if=" browser == 'IE'" style="font-size: 50px;text-shadow:none">{{ attend.specialCount }}</p>
              </div>
              <p class="name">特种人员</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="list-group-item no-move">
        <div class="first-line">
          <div class="first-head">
            <p><span class="crile bg-color3"></span>在场人员</p>
            <p><span class="color7">{{ persent.allNowCount }}</span>人</p>
            <p>在场率<span class="color7"> {{ persent.countRate }}%</span></p>
          </div>
          <div class="first-body">
            <div class="first-body-item">
              <div class="num color8">
                <p
                    v-for="(item,index) in numLen4"
                    v-if=" browser != 'IE'"
                    :key="index"
                    :class="{'number-item': !isNaN(item) }"
                >
                                    <span v-if="!isNaN(item)">
                                    <i ref="numberItem3">0123456789</i>
                                    </span>
                  <span v-else>{{ item }}</span>
                </p>
                <p v-if=" browser == 'IE'" style="font-size: 50px;text-shadow:none">{{ persent.manageCount }}</p>
              </div>
              <p class="name">管理人员</p>
            </div>
            <div class="first-body-item">
              <div class="num color8">
                <p
                    v-for="(item,index) in numLen5"
                    v-if=" browser != 'IE'"
                    :key="index"
                    :class="{'number-item': !isNaN(item) }"
                >
                                    <span v-if="!isNaN(item)">
                                    <i ref="numberItem4">0123456789</i>
                                    </span>
                  <span v-else>{{ item }}</span>
                </p>
                <p v-if=" browser == 'IE'" style="font-size: 50px;text-shadow:none">{{ persent.workersCount }}</p>
              </div>
              <p class="name">建筑工人</p>
            </div>
            <div class="first-body-item">
              <div class="num color8">
                <p
                    v-for="(item,index) in numLen6"
                    v-if=" browser != 'IE'"
                    :key="index"
                    :class="{'number-item': !isNaN(item) }"
                >
                                    <span v-if="!isNaN(item)">
                                    <i ref="numberItem5">0123456789</i>
                                    </span>
                  <span v-else>{{ item }}</span>
                </p>
                <p v-if=" browser == 'IE'" style="font-size: 50px;text-shadow:none">{{ persent.specialCount }}</p>
              </div>
              <p class="name">特种人员</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="list-group-item no-move">
        <!-- <div class="first-line">
                <div class="first-head">
                    <p><span class="crile bg-color3"></span>今日实名制上传</p>
                </div>
                <div class="first-body" style="justify-content: space-around;">
                    <div class="first-body-item" style="cursor: pointer;"  @click=intoReal(1)>
                        <div class="num color10">
                            <p
                                :class="{'number-item': !isNaN(item) }"
                                v-for="(item,index) in numLen7"
                                :key="index"
                                v-if=" browser != 'IE'"
                            >
                                <span v-if="!isNaN(item)">
                                <i  ref="numberItem7">0123456789</i>
                                </span>
                                <span v-else>{{item}}</span>
                            </p>
                            <p style="font-size: 50px;text-shadow:none" v-if=" browser == 'IE'">{{realNameData.successCount}}</p>
                        </div>
                        <p class="name">上传人数</p>
                    </div>
                    <div class="first-body-item"  style="cursor: pointer;"  @click=intoReal(2)>
                        <div class="num color6">
                            <p
                                :class="{'number-item': !isNaN(item) }"
                                v-for="(item,index) in numLen8"
                                :key="index"
                                v-if=" browser != 'IE'"
                            >
                                <span v-if="!isNaN(item)">
                                <i  ref="numberItem8">0123456789</i>
                                </span>
                                <span v-else>{{item}}</span>
                            </p>
                            <p style="font-size: 50px;text-shadow:none" v-if=" browser == 'IE'">{{realNameData.failCount}}</p>
                        </div>
                        <p class="name">未上传人数</p>
                    </div>
                </div>
               </div> -->

        <div class="first-line">
          <div class="first-head" style="z-index: 10;">
            <p><span class="crile bg-color3"></span>人员动态</p>
            <p>累计采集<span class="color7">{{ syn.zs }}</span>人</p>
            <p>实名占比<span class="color7"> {{ syn.smRate }}</span></p>
          </div>
          <div class="first-body">
            <div class="echart1">
              <div id="myChart1" style="width:100%; height:100%"></div>
            </div>
            <div class="first-gress">
              <div class="first-gress-con">
                <p class="color7">在职（{{ syn.zz }}/{{ syn.zs }}）</p>
                <p class="progressH"><span :style="{width:syn.zzLv}" class="inner bg-color3"></span></p>
                <p class="color9">离职（{{ syn.lz }}/{{ syn.zs }}）</p>
                <p class="progressH"><span :style="{width:syn.lzLv}" class="inner bg-color4"></span></p>
                <p class="color6">未分配（{{ syn.wzz }}/{{ syn.zs }}）</p>
                <p class="progressH"><span :style="{width:syn.wzzLv}" class="inner bg-color5"></span></p>
              </div>
            </div>
          </div>
        </div>

      </el-col>
    </el-row>
    <draggable
        v-model="list"
        class="list-group"
        tag="el-row"
        v-bind="{
            animation: 200,
            group: 'description',
            disabled: false,
            ghostClass: 'ghost'
            }"
    >
      <!-- <el-row :gutter="20" style="margin:0;"> -->
      <!-- ======================================================第四个盒子========================================================= -->
      <el-col v-for="box in list" :key="box.id" :span="8" class="list-group-item">
        <div v-if="box.id==4 && groupId!=1549310060570570753" class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>合同信息</p>
          </div>
          <div class="second-total">
            <p class="total-p">应签合同<span class="color6">{{ agreeNum.yqht }}</span>人</p>
            <p class="total-p">已网签<span class="color6">{{ agreeNum.ywq }}</span>人<i v-for="(item,index) in agreeicon2"
                                                                                    :key="index"
                                                                                    class="el-icon-s-check color6"></i>
            </p>
            <p class="total-p">未网签<span class="color6">{{ agreeNum.wxq }}</span>人<i v-for="(item,index) in agreeicon1"
                                                                                    :key="index"
                                                                                    class="el-icon-s-check color6"></i>
            </p>
          </div>
          <div class="second-body" style="height:calc( 85% - 4vh );">
            <div class="table-head color1">
              <p>姓名</p>
              <p>入职时间</p>
              <p v-if="groupId!=1506900977511251969">合同状态</p>
            </div>
            <div class="table-head-list">
              <ul :class="{anim:animate==true}">
                <li v-for="item in tableAgree" :key="item.id" class="table-li">
                  <p>{{ item.name }}</p>
                  <p>{{ item.create_date }}</p>
                  <p v-if="groupId!=1506900977511251969">
                    <span v-if="item.status=='已网签'" class="color10">已网签</span>
                    <span v-else class="color6">未网签</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 能达 -->
        <div v-else-if="box.id==4&& groupId=='1549310060570570753' " class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>班组出勤</p>
          </div>
          <div class="second-body" style="height:85%;">
            <ul :class="{anim:animate2==true}">
              <li v-for="(item,index) in attendTeam" :key="index" class="table-li table-li-team">
                <p :title="item.teamsName"><span class="nowrap"
                                                 style="width:100%;display:inline-block;">{{ item.teamsName }}</span>
                </p>
                <p>{{ item.zzCount }}</p>
                <p>出勤<span class="color6" style="margin-left:0.5vh;">{{ item.cqCount }}</span></p>
                <p>出勤率<span class="color6" style="margin-left:0.5vh;">{{ item.lv }}%</span></p>
              </li>
            </ul>
          </div>
        </div>
        <!-- == -->
        <!-- ========================================第五个盒子============================================ -->
        <div v-else-if="box.id==5&&groupId!=1549310060570570753" class="second-line">
          <el-carousel height='100%' style="width:100%;height:100%">
            <el-carousel-item v-for="(item,index) in imgList" :key="index" style="width:100%;height:100%">
              <img v-if="item!==''" :src="httpCtx+item" alt="" style="width:100%;height:100%">
              <!-- <p>wwwwwwwwwwwwwwwwwwwwww</p> -->
            </el-carousel-item>
          </el-carousel>
          <!-- <div class="second-head">
                            <p><span class="crile bg-color3"></span>健康码管控系统</p>
                        </div>
                        <div class="num-box"> -->
          <!-- <div class="num-box-item">
                                <div  class="txt" style="width:100%;height:100%;position: relative;background:#597EF0;border-radius: 0.5vh;">
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">{{codeNum.registered}}</p>
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">今日入场</p>
                                </div>
                            </div> -->
          <!-- <div class="num-box-item">
                                <div  class="txt" style="width:100%;height:100%;position: relative;background:#0CCF93;border-radius: 0.5vh;">
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">{{codeNum.green}}</p>
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">正常绿码</p>
                                </div>
                            </div> -->
          <!-- <div class="num-box-item">
                                <div class="txt" style="width:100%;height:100%;position: relative;background:#F8DA2A;border-radius: 0.5vh;">
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">{{codeNum.yellow}}</p>
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">异常黄码</p>
                                </div>
                            </div> -->
          <!-- <div class="num-box-item">
                                <div  class="txt" style="width:100%;height:100%;position: relative;background:#F9693B;border-radius: 0.5vh;">
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">{{codeNum.red}}</p>
                                    <p style="width:100%;padding-left:1vw;text-align: left;color:#fff;">异常红码</p>
                                </div>
                            </div> -->
          <!-- </div> -->
          <!-- <div class="second-body" style="height:calc(85% - 7vh);">
                            <div class="table-head-list" style="height:100%;">
                                <ul :class="{anim1:animate5==true}">
                                    <li class="table-li" v-for="(item,index) in codeList" :key="index" style="height:7vh;">
                                        <p style="width:20%;">{{item.name}}</p>
                                        <p style="width:20%;">
                                            <img :src="httpCtx + item.idcardPhoto" style="height:6vh;" />
                                        </p>
                                        <p style="width:40%;">
                                            <span >{{item.clockTime}}</span>
                                        </p>
                                        <p style="width:20%;">
                                            <img :src="item.codeImg" style="height:6vh;" />
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div> -->
          <!-- <div class="second-head">
                            <p><span class="crile bg-color3"></span>安全教育</p>
                        </div>
                        <div class="second-body" style="height:65%;">
                            <div class="hight-pie1" id="pie1"></div>
                            <div class="hight-pie1" id="pie2"></div>
                        </div>
                        <div class="second-footer" style="hegiht:20%;">
                            <p class="total-p">未考试人数<span class="color6">{{edc.nopaper}}</span>人</p>
                            <p class="total-p">未教育人数<span class="color6">0</span>人</p>
                        </div> -->
        </div>
        <div v-else-if="box.id==5&&groupId==1549310060570570753" class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>今日教育入厂人员</p>
          </div>
          <div class="second-body" style="height:85%;">
            <div class="table-head color1">
              <p style="width:20%;">姓名</p>
              <p style="width:50%;">公司</p>
              <p style="width:30%;">班组</p>
              <p style="width:30%;">考试是否通过</p>
            </div>
            <div class="table-head-list">
              <ul :class="{anim:animateB==true}">
                <li v-for="item in DayEducationList" :key="item.id" class="table-li table-li-team">
                  <p style="width:20%;">{{ item.name }}</p>
                  <p class="nowrap" style="width:50%; display:inline-block;">{{ item.endName }}</p>
                  <p class="nowrap" style="width:30%; display:inline-block;">{{ item.teamsName }}</p>
                  <p style="width:30%;">
                    <span v-if="item.pass_flag==0">通过</span>
                    <span v-if="item.pass_flag==1">未通过</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- =============================================第六个盒子============================================= -->
        <div v-else-if="box.id==6" class="second-line">
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <!-- <div class="second-head">
                            <p><span class="crile bg-color3"></span>参建单位</p>
                        </div>
                         <div class="second-body" style="height:85%;">
                          <div class="table-head color1">
                            <p style="width:50%;">单位名称</p>
                            <p style="width:20%;">联系人</p>
                            <p style="width:30%;">联系电话</p>
                          </div>
                          <div class="table-head-list">
                            <ul :class="{anim:animate3==true}">
                              <li class="table-li table-li-team" v-for="item in ents" :key="item.id">
                                <p :title="item.entName" style="width:50%;"><span style="width:100%;display:inline-block;"
                                    class="nowrap">{{item.entName}}</span></p>
                                <p style="width:20%;">{{item.personName}}</p>
                                <p style="width:30%;">{{item.personPhone}}</p>
                              </li>
                            </ul>
                          </div>
                        </div> -->


          <div class="second-head">
            <p><span class="crile bg-color3"></span>质安检查</p>
          </div>
          <div class="second-body" style="height:85%;">
            <div class="table-head color1">
              <p style="width:20%;">检查人</p>
              <p style="width:50%;">检查时间</p>
              <p style="width:30%;">检查结果</p>
              <p style="width:30%;">处理状态</p>
            </div>
            <div class="table-head-list">
              <ul :class="{anim:animate10==true}">
                <li v-for="item in proQsList" :key="item.id" class="table-li table-li-team">
                  <p style="width:20%;"><span class="nowrap"
                                              style="width:100%;display:inline-block;">{{ item.reportName }}</span></p>
                  <p style="width:50%;">{{ item.happenDate }}</p>
                  <p style="width:30%;"><span v-if="item.checkResult=='无'"
                                              style="color:#1ed76d;">{{ '合格' || '--' }}</span>
                    <span v-else-if="item.checkStatus=='已处理'" style="color:#E6A23C">{{ item.checkResult }}</span>
                    <span v-else style="color:red;">{{ '待整改' || '--' }}</span></p>
                  <p style="width:30%;">{{ item.checkStatus }}</p>
                </li>
              </ul>
            </div>
          </div>

          <!-- <div class="second-head">
                            <p><span class="crile bg-color3"></span>今日采集</p>
                        </div> -->
          <!-- <div class="first-line" style="height:100%">
                          <div class="first-head" style="z-index: 10;">
                              <p><span class="crile bg-color3"></span>人员动态</p>
                              <p>累计采集<span class="color7">{{syn.zs}}</span>人</p>
                              <p>实名占比<span class="color7"> {{syn.smRate}}</span></p>
                          </div>
                          <div class="first-body">
                              <div class="echart1">
                                  <div id="myChart1" style="width:100%; height:100%"></div>
                              </div>
                              <div class="first-gress">
                                  <div class="first-gress-con">
                                      <p class="color7">在职（{{syn.zz}}/{{syn.zs}}）</p>
                                      <p class="progressH"><span class="inner bg-color3" :style="{width:syn.zzLv}"></span></p>
                                      <p class="color9">离职（{{syn.lz}}/{{syn.zs}}）</p>
                                      <p class="progressH"><span class="inner bg-color4" :style="{width:syn.lzLv}"></span></p>
                                      <p class="color6">未分配（{{syn.wzz}}/{{syn.zs}}）</p>
                                      <p class="progressH"><span class="inner bg-color5" :style="{width:syn.wzzLv}"></span></p>
                                  </div>
                              </div>
                          </div>
                        </div> -->


        </div>
        <!-- ====================================================第七个盒子================================================ -->
        <div v-else-if="box.id==7&&groupId!=='1549310060570570753' " class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>班组出勤</p>
          </div>
          <div class="second-body" style="height:85%;">
            <ul :class="{anim:animate2==true}">
              <li v-for="(item,index) in attendTeam" :key="index" class="table-li table-li-team">
                <p :title="item.teamsName"><span class="nowrap"
                                                 style="width:100%;display:inline-block;">{{ item.teamsName }}</span>
                </p>
                <p>{{ item.zzCount }}</p>
                <p>出勤<span class="color6" style="margin-left:0.5vh;">{{ item.cqCount }}</span></p>
                <p>出勤率<span class="color6" style="margin-left:0.5vh;">{{ item.lv }}%</span></p>
              </li>
            </ul>
          </div>
        </div>
        <div v-else-if="box.id==7&&groupId=='1549310060570570753' " class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>今日入厂施工人员</p>
          </div>
          <div class="second-body" style="height:85%;">
            <div class="table-head color1">
              <p style="width:20%;">公司名称</p>
              <p style="width:50%;">班组名称</p>
              <p style="width:30%;">施工人数</p>

            </div>
            <div class="table-head-list">
              <ul :class="{anim:animateA==true}">
                <li v-for="item in TeamsAttendList" :key="item.id" class="table-li table-li-team">
                  <p style="width:20%;"><span class="nowrap"
                                              style="width:100%;display:inline-block;">{{ item.endName || '--' }}</span>
                  </p>
                  <p style="width:50%;">{{ item.teamsName }}</p>
                  <p style="width:30%;">{{ item.cqCount }}</p>
                  <!-- <p style="width:30%;">{{item.checkStatus}}</p> -->
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- ======================================================第八个盒子========================================== -->
        <div v-else-if="box.id==8" class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>年龄占比</p>
          </div>
          <div class="second-total" style="padding-right: 20%;justify-content: flex-end;height:2vh;">
            <p class="total-p" style="text-align: right;padding-right: 6%;">
              <img v-for="(item, index) in ageMale" :key="index" src="../../assets/image/male.png"
                   style="width:1vh;margin-right:0.1vh;display: inline-block;"/>
            </p>
            <p class="total-p">男性占比 <span class="color7">{{ ageNum.man }}%</span></p>
          </div>
          <div class="second-total" style="padding-right: 20%;justify-content: flex-end;height:2vh;">
            <p class="total-p" style="text-align: right;padding-right: 6%;">
              <img v-for="(item, index) in ageFemale" :key="index" src="../../assets/image/female.png"
                   style="width:1vh;margin-right:0.1vh;display: inline-block;height: 88%;"/>
            </p>
            <p class="total-p">女性占比 <span class="color9">{{ ageNum.woman }}%</span></p>
          </div>
          <div class="second-body" style="height:calc(85% - 5vh);">
            <div id="bar1" class="hight-Bar"></div>
          </div>
        </div>
        <!-- ===============================================第九个盒子========================================= -->
        <div v-else-if="box.id==9&&groupId == '1549310060570570753'" class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>今日出勤特种人员</p>
          </div>
          <div class="second-body">
            <div class="table-head color1">
              <p>姓名</p>
              <p>岗位</p>
              <p>班组</p>
      
            </div>
            <div class="table-head-list">
              <ul :class="{anim1:animate4S==true}">
                <li v-for="(item,index) in teqinList" :key="index" class="table-li" style="height:7.5vh;">
                  <p>{{ item.name }}</p>
                  <p>
                     <span>{{ item.label }}</span>
                  </p>
                  <p>
                  <span class="nowrap">{{item.teamsName}}</span>
                  </p>
           
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else-if="box.id==9&&groupId !== '1549310060570570753'" class="second-line">
          <div class="second-head">
            <p><span class="crile bg-color3"></span>关键岗位</p>
          </div>
          <div class="second-body">
            <div class="table-head color1">
              <p>姓名</p>
              <p>照片</p>
              <p>岗位</p>
              <p>出勤率</p>
            </div>
            <div class="table-head-list">
              <ul :class="{anim1:animate4==true}">
                <li v-for="(item,index) in psotList" :key="index" class="table-li" style="height:7.5vh;">
                  <p>{{ item.name }}</p>
                  <p>
                    <img :src="item.idcardPhoto" style="height:6vh;"/>
                  </p>
                  <p>
                    <span>{{ item.label }}</span>
                  </p>
                  <p>
                    <span>{{ item.csSum }}%</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-col>
      <!-- </el-row> -->
    </draggable>
  </div>
</template>
<script>

import draggable from 'vuedraggable'//导入拖拽组件
import HighCharts from 'highcharts'
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
import middle from '../../plugins/middleUtil'

export default {
  components: {
    draggable
  },
  data() {
    return {
      teqinList:[],
      TeamsAttendList: [],
      DayEducationList: [],
      imgList: [],
      httpCtx: base.httpCtx,
      proQsList: [],    //  质安检查
      ents: [],   //参建单位
      list: [
        {id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}, {id: 7}, {id: 8}, {id: 9}
      ],
      // zzWidth:'65%',
      dataText: '数据加载中...',
      tableAgree: [],
      agreeNum: {wxq: 0, yqht: 0, ywq: 0, wlv: 0, ylv: 0},
      agreeicon1: ['1'],
      agreeicon2: ['1'],
      animate: false,
      animate1: false,
      animate2: false,
      animate3: false,
      animate4: false,
       animate4S: false,
      animate44: false,
      animate5: false,
      animate6: false,
      animate7: false,
      animate10: false,
      animateA: false,
      animateB: false,
      groupId: '',
      attend: {  //今日出勤
        manageCount: 0, //管理人员数量
        workersCount: 0, //工人人员数量
        specialCount: 0, //特殊人员数量
        allNowCount: 0,  //今日出勤的总人数
        countRate: 0, //在班组的所有人员
      },
      persent: {  //在场人员
        manageCount: 0, //管理人员数量
        workersCount: 0, //工人人员数量
        specialCount: 0, //特殊人员数量
        allNowCount: 0,  //今日出勤的总人数
        countRate: 0, //在班组的所有人员
      },
      realNameData: {
        failCount: 0,
        successCount: 0,
      },
      syn: {
        zz: 0,   //在职
        lz: 0,   //离职
        wzz: 0,  //未入职
        wsm: 0,  //未实名
        sm: 0,   //采集人数
        zs: 0,   //总人数
        smRate: 0,//实名率
        zzLv: 0,  //在职比例
        wzzLv: 0, //未在职比例
        lzLv: 0, //未实名比例
      },
      cjData: [],//采集列表
      attendTeam: [],//班组出勤列表
      ageBar: {
        xy25: 0,
        xy30: 0,
        xy35: 0,
        xy40: 0,
        xy45: 0,
        xy50: 0,
        xy55: 0,
        sx60: 0
      },
      ageNum: {
        man: 0,
        woman: 0
      },
      ageMale: [],
      ageFemale: [],
      psotList: [],//关键岗位
      numLen1: ['0'],//今日出勤 - 管理人员长度
      numLen2: ['0'],//今日出勤 - 建筑人员长度
      numLen3: ['0'],//今日出勤 - 特种人员长度
      numLen4: ['0'],//在场人员 - 管理人员长度
      numLen5: ['0'],//在场人员 - 建筑人员长度
      numLen6: ['0'],//在场人员 - 特种人员长度
      numLen7: ['0'],//实名制上传 - 已上传长度
      numLen8: ['0'],//实名制上传 - 未上传长度
      edc: { //安全教育
        allNum: 0,
        paperNum: 0,
        nopaper: 0,
      },
      timer1: undefined,
      timer2: undefined,
      timer3: undefined,
      timer4: undefined,
      timer4S: undefined,
      timer5: undefined,
      timer6: undefined,
      timer10: undefined,
      timerA: undefined,
      timerB: undefined,
      codeList: [ //安康码列表
      ],
      codeNum: { //安康码数据
        registered: 0,
        green: 0,
        yellow: 0,
        red: 0
      },
      browser: '',

      flag1: false,//是否获取出勤数据
      flag2: false,//是否获取在场数据
      isAudio: false,//是否正在播放
    }
  },
  watch: {
    '$store.state.groupId': function (val, old) {
      this.groupId = util.session.get('groupId')
      if (this.groupId == '1203536946790273025') {
        this.list = [
          {id: 1}, {id: 2}, {id: 3}, {id: 6}, {id: 7}, {id: 8}, {id: 9}
        ]
      }
      if (this.timer1) {
        window.clearInterval(this.timer1)
      }
      if (this.timer2) {
        window.clearInterval(this.timer2)
      }
      if (this.timer3) {
        window.clearInterval(this.timer3)
      }
      if (this.timer4) {
        window.clearInterval(this.timer4)
      }
         if (this.timer4S) {
        window.clearInterval(this.timer4S)
      }
      if (this.timer5) {
        window.clearInterval(this.timer5)
      }
      if (this.timer6) {
        window.clearInterval(this.timer6)
      }
      if (this.timer10) {
        window.clearInterval(this.timer10)
      }
      if (this.timerA) {
        window.clearInterval(this.timerA)
      }
      if (this.timerB) {
        window.clearInterval(this.timerB)
      }
      this.setChart1() //展示人员动态饼状图
      //this.showPie3D() // 展示安全教育 - 1
      // this.showPie3D1()  //展示安全教育 - 2
      this.showBar()  // 展示年龄占比
      this.attendData() // 今日出勤
      this.getPresent() //在场人员
      this.getDynPerson()  //人员动态
      this.getCj() //采集数据
      this.teamAttend() //班组出勤
      this.ageData() //年龄占比
      this.getAgree() //合同信息
      // this.edcData()//安全教育
      //setInterval(this.scroll1,1800) // 合同滚动
      //setInterval(this.scroll4,1600) // 合同滚动
      this.getPostList()//获取关键岗位列表
      this.getAnkongCode()//获取安康码
      this.realName() //实名制
    }
  },
  mounted() {
    if (this.timer1) {
      window.clearInterval(this.timer1)
    }
    if (this.timer2) {
      window.clearInterval(this.timer2)
    }
    if (this.timer3) {
      window.clearInterval(this.timer3)
    }
    if (this.timer4) {
      window.clearInterval(this.timer4)
    }
      if (this.timer4S) {
      window.clearInterval(this.timer4S)
    }
    if (this.timer5) {
      window.clearInterval(this.timer5)
    }
    if (this.timer6) {
      window.clearInterval(this.timer6)
    }
    if (this.timer10) {
      window.clearInterval(this.timer10)
    }
    if (this.timerA) {
      window.clearInterval(this.timerA)
    }
    if (this.timerB) {
      window.clearInterval(this.timerB)
    }
    this.groupId = util.session.get('groupId')
    if (this.groupId == '1203536946790273025') {
      this.list = [
        {id: 1}, {id: 2}, {id: 3}, {id: 6}, {id: 7}, {id: 8}, {id: 9}
      ]
    }
    middle.$emit('isHome', {flag: true})
    if (this.groupId && this.groupId != '') {
      this.setChart1() //展示人员动态饼状图
      //this.showPie3D() // 展示安全教育 - 1
      // this.showPie3D1()  //展示安全教育 - 2
      this.showBar()  // 展示年龄占比
      this.attendData() // 今日出勤
      this.getPresent() //在场人员
      this.getDynPerson()  //人员动态
      this.getCj() //采集数据
      this.teamAttend() //班组出勤
      this.ageData() //年龄占比
      this.getAgree() //合同信息
      // this.edcData() // 安全教育
      //setInterval(this.scroll4,1600) // 合同滚动
      this.getPostList()//获取关键岗位列表
      this.getAnkongCode()//获取安康码
      this.realName() //实名制
      this.browser = this.isbrowser()
    }
    this.getData1()
    this.getProjectById()
    this.getAttendNew()
    this.selectDayEducation()
    this.selectSpecialAttend()
  },
  methods: {
    async selectSpecialAttend(){
const data=await myHttp.selectSpecialAttend({
projectId:util.session.get('groupId')
 
})
console.log('特勤人员列表---》',data);
this.teqinList=data.data.data
let that=this
  setTimeout(function () {
     that.timer4S = setInterval(that.scroll4S, 1200) 
          //  setInterval(this.scroll4S, 1200) // 班组考勤滚动
        }, 1000)
    },
    async getProjectById() {
      const data = await myHttp.getProjectById({
        id: util.session.get('groupId')
      })
      if (data.data.code == 200) {
        let imgStr = data.data.data.project.photoPath
        if (imgStr && imgStr !== '') {
          this.imgList = imgStr.split(',')
        }
      }
    },
    isbrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1;
      if (isOpera) {//判断是否Opera浏览器
        return "Opera"
      } else if (userAgent.indexOf("Firefox") > -1) {//判断是否Firefox浏览器
        return "FF";
      } else if (userAgent.indexOf("Chrome") > -1) {//判断是否Chrome浏览器
        return "Chrome";
      } else if (userAgent.indexOf("Safari") > -1) {//判断是否Safari浏览器
        return "Safari";
      } else {//判断是否IE浏览器
        return "IE";
      }
      ;
    },

    //获取项目检查
    getData1() {
      var dispose = 3
      var that = this
      myHttp.selectQsListByProjectIdPage({
        projectId: util.session.get('groupId'),
        starTime: '',
        endTime: '',
        form: '1',
        type: '',
        dispose: dispose,
        pageNum: 1,
        pageSize: 100
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.qsList.list || []
          for (var i = 0; i < list.length; i++) {
            list[i].pic = list[i].picUrls && list[i].picUrls != '' ? base.httpCtx + (list[i].picUrls.split(',')[0]) : require('../../assets/image/project.png')
            list[i].affirmpic = list[i].affirmPicUrls && list[i].affirmPicUrls != '' ? base.httpCtx + (list[i].affirmPicUrls.split(',')[0]) : require('../../assets/image/zanwutupian.png')
          }
          that.proQsList = list
          setTimeout(function () {
            that.timer10 = setInterval(that.scroll10, 1300) // 班组考勤滚动
          }, 500)
        }
      })
    },

    //今日出勤数据
    attendData() {
      var that = this
      myHttp.dayAttendance({
        projectId: util.session.get('groupId')
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var data = resp.data.data || {}
          // if(that.groupId=='1319932254633291777'){
          //     data.allTeamsCount = data.allTeamsCount + (75 - parseInt(data.specialCount))
          //     data.specialCount = 75
          // }
          data.countRate = data.allTeamsCount && data.allTeamsCount != '0' ? (parseInt(data.allNowCount) / parseInt(data.allTeamsCount) * 100).toFixed(1) : 0
          that.attend = data
          that.refreshAttendData(data.manageCount, that.$refs.numberItem, 1)
          that.refreshAttendData(data.workersCount, that.$refs.numberItem1, 2)
          that.refreshAttendData(data.specialCount, that.$refs.numberItem2, 3)
        }
        that.flag1 = true
        that.showAduit()
      })
    },
    //整理今日出勤数据
    refreshAttendData(data, items, index) {
      var len1 = data.toString().length
      if (index == 1) {
        this.numLen1 = []
        for (var i = 0; i < len1; i++) {
          this.numLen1.push('0')
        }
      } else if (index == 2) {
        this.numLen2 = []
        for (var i = 0; i < len1; i++) {
          this.numLen2.push('0')
        }
      } else if (index == 3) {
        this.numLen3 = []
        for (var i = 0; i < len1; i++) {
          this.numLen3.push('0')
        }
      }
      var that = this
      setTimeout(function () {
        that.setNumberTransform(data, items)
      }, 100)
    },
    //在场人员
    getPresent() {
      var that = this
      myHttp.dayInAttendance({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var data = resp.data.data || {}
          // if(that.groupId=='1319932254633291777'){
          //     data.allTeamsCount = data.allTeamsCount + (72 - parseInt(data.specialCount))
          //     data.specialCount = 72
          // }
          data.countRate = data.allTeamsCount && data.allTeamsCount != '0' ? (parseInt(data.allNowCount) / parseInt(data.allTeamsCount) * 100).toFixed(1) : 0
          that.persent = data
          that.refreshPreData(data.manageCount, that.$refs.numberItem3, 1)
          that.refreshPreData(data.workersCount, that.$refs.numberItem4, 2)
          that.refreshPreData(data.specialCount, that.$refs.numberItem5, 3)
        }
        that.flag2 = true
        that.showAduit()
      })
    },

    //整理今日出勤数据
    refreshPreData(data, items, index) {
      var len1 = data.toString().length
      if (index == 1) {
        this.numLen4 = []
        for (var i = 0; i < len1; i++) {
          this.numLen4.push('0')
        }
      } else if (index == 2) {
        this.numLen5 = []
        for (var i = 0; i < len1; i++) {
          this.numLen5.push('0')
        }
      } else if (index == 3) {
        this.numLen6 = []
        for (var i = 0; i < len1; i++) {
          this.numLen6.push('0')
        }
      }
      var that = this
      setTimeout(function () {
        that.setNumberTransform(data, items)
      }, 100)
    },
    //语音播报出勤和在场人数
    showAduit() {
      var name = util.session.get('groupName') || ''
      if (this.flag1 && this.flag2 && name != '') {
        // this.isAudio = true
        var ttsText = util.session.get('groupName') + '今日出勤' + this.attend.allNowCount + '人，当前在场' + this.persent.allNowCount + '人';
        new Audio(
            'http://tts.baidu.com/text2audio?cuid=baiduid&ctp=1&vol=15&lan=zh&per=1&pit=9&spd=6&tex=' + ttsText + '&tok=' + base.videoToken
        ).play();
      }
    },
    // 实名制上传
    realName() {
      var that = this
      myHttp.findTeamsPersonDeTuoCount({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var data = JSON.parse(resp.data.data)
          that.realNameData = data.data
          //  data =JSON.parse(data)
          that.refreshReaData(data.data.failCount, that.$refs.numberItem8, 1)
          that.refreshReaData(data.data.successCount, that.$refs.numberItem7, 2)
        }
      })
    },
    refreshReaData(data, items, index) {
      var len1 = data.toString().length
      if (index == 1) {
        this.numLen8 = []
        for (var i = 0; i < len1; i++) {
          this.numLen8.push('0')
        }
      } else if (index == 2) {
        this.numLen7 = []
        for (var i = 0; i < len1; i++) {
          this.numLen7.push('0')
        }
      }
      var that = this
      setTimeout(function () {
        that.setNumberTransform(data, items)
      }, 100)
    },
    //人员动态
    getDynPerson() {
      var that = this
      myHttp.personDynamic({
        projectId: this.groupId
      }).then(function (resp) {
        var data = resp.data.data || {}
        data.smRate = data.zs && data.zs != '0' ? (parseInt(data.sm) / parseInt(data.zs) * 100).toFixed(1) + '%' : '0%'
        data.zzLv = data.zs && data.zs != '0' ? (parseInt(data.zz) / parseInt(data.zs) * 100).toFixed(1) + '%' : '0%'
        data.wzzLv = data.zs && data.zs != '0' ? (parseInt(data.wzz) / parseInt(data.zs) * 100).toFixed(1) + '%' : '0%'
        data.lzLv = data.zs && data.zs != '0' ? (parseInt(data.lz) / parseInt(data.zs) * 100).toFixed(1) + '%' : '0%'
        that.syn = data
        that.setChart1()
      })
    },
    //采集数据
    getCj() {
      var that = this
      myHttp.dayCollect({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.entity || []
          for (var i = 0; i < list.length; i++) {
            list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto != '' ? base.httpCtx + list[i].idcardPhoto : require('../../assets/image/zanwutupian.png')
          }
          that.cjData = list
          setTimeout(function () {
            that.timer2 = setInterval(that.scroll2, 1800) // 今日采集滚动
          }, 1000)
        }
      })
    },
    //获取合同信息
    getAgree() {
      var that = this
      myHttp.findTeamsPerContract({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.list || []
          that.agreeNum.wxq = resp.data.data.wxq
          that.agreeNum.yqht = resp.data.data.yqht
          that.agreeNum.ywq = resp.data.data.ywq
          var wlv = that.agreeNum.yqht == 0 ? 0 : (parseInt(that.agreeNum.wxq) / parseInt(that.agreeNum.yqht) * 10).toFixed(0)
          var ylv = that.agreeNum.yqht == 0 ? 0 : (parseInt(that.agreeNum.ywq) / parseInt(that.agreeNum.yqht) * 10).toFixed(0)
          that.agreeicon1 = []
          that.agreeicon2 = []
          for (var i = 0; i < wlv; i++) {
            that.agreeicon1.push(i)
          }
          for (var j = 0; j < ylv; j++) {
            that.agreeicon2.push(i)
          }
          that.tableAgree = list
          that.timer1 = setInterval(that.scroll1, 1800) // 合同滚动
        }
      })
    },
    //获取教育
    edcData() {
      var that = this
      myHttp.safetyEducationPro({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var data = resp.data.data
          data.paperNum = data.paperNum ? data.paperNum : 0
          data.nopaper = parseInt(data.allNum) - parseInt(data.paperNum)
          that.edc = data
          that.showPie3D()
        }
      })
    },
    //班组出勤
    teamAttend() {
      var that = this
      myHttp.getAttendNewHome({
        projectId: this.groupId,
        date: util.myTime.getCurTime()
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.list || []
          for (var i = 0; i < list.length; i++) {
            list[i].lv = list[i].zzCount == 0 ? '0.0' : (parseInt(list[i].cqCount) / parseInt(list[i].zzCount) * 100).toFixed(1)
          }
          that.attendTeam = list
          setTimeout(function () {
            that.timer3 = setInterval(that.scroll3, 1300) // 班组考勤滚动
          }, 500)
        }
      })
    },
    //年龄占比
    ageData() {
      var that = this
      myHttp.ageRatio({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var data = resp.data.data || {xy25: 0, xy30: 0, xy35: 0, xy40: 0, xy45: 0, xy50: 0, xy55: 0, sy60: 0}
          that.ageBar = data
          var all = parseInt(data.Man) + parseInt(data.woman)
          that.ageNum.man = all == 0 ? 0 : (parseInt(data.Man) / parseInt(all) * 100).toFixed(1)
          that.ageNum.woman = all == 0 ? 0 : (parseInt(data.woman) / parseInt(all) * 100).toFixed(1)
          that.showBar()
          var male = parseInt(that.ageNum.man / 10)
          that.ageMale = []
          that.ageFemale = []
          for (var i = 0; i < male; i++) {
            that.ageMale.push('0')
          }
          for (var j = 0; j < (10 - male); j++) {
            that.ageFemale.push('0')
          }
        }
      })
    },

    //获取安康码数据
    getAnkongCode() {
      var that = this
      myHttp.dayStatisticalAnKang({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.codeNum.green = resp.data.data.green || 0
          that.codeNum.yellow = resp.data.data.yellow || 0
          that.codeNum.red = resp.data.data.red || 0
        }
      })

      myHttp.selectAnKangCodeByProjectId({
        pageNum: 1,
        pageSize: 100860,
        healthLevel: '2',
        projectId: this.groupId,
      }).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.PageInfo.list || []
              for (var i = 0; i < list.length; i++) {
                if (list[i].healthLevel == '1') {
                  list[i].codeImg = require('../../assets/image/anKang-gress.png')
                } else if (list[i].healthLevel == '2') {
                  list[i].codeImg = require('../../assets/image/anKang-yellow.png')
                } else if (list[i].healthLevel == '3') {
                  list[i].codeImg = require('../../assets/image/anKang-red.png')
                } else if (list[i].healthLevel == '4' || list[i].healthLevel == '0') {
                  list[i].codeImg = require('../../assets/image/anKang-no.png')
                }
              }
              that.codeList = list
              setTimeout(function () {
                that.timer5 = setInterval(that.scroll5, 1200) // 班组考勤滚动
              }, 1000)
            }
          })

      // myHttp.anKangCodeList({
      //     projectId:this.groupId
      // }).then(function(resp){
      //     if(resp.data.code=='200'){
      //         var list = resp.data.data.list||[]
      //         that.codeNum.registered = resp.data.data.registered||0
      //         that.codeNum.green = resp.data.data.green||0
      //         that.codeNum.yellow = resp.data.data.yellow||0
      //         that.codeNum.red = resp.data.data.red||0
      //         for(var i=0;i<list.length;i++){
      //             list[i].idcardPhoto = list[i].idcardPhoto && ''!=list[i].idcardPhoto?base.httpCtx+list[i].idcardPhoto:require('../../assets/image/zanwutupian.png')
      //             if(list[i].healthLevel=='1'){
      //                 list[i].codeImg = require('../../assets/image/anKang-gress.png')
      //             }else if(list[i].healthLevel=='2'){
      //                 list[i].codeImg = require('../../assets/image/anKang-yellow.png')
      //             }else if(list[i].healthLevel=='3'){
      //                 list[i].codeImg = require('../../assets/image/anKang-red.png')
      //             }else if(list[i].healthLevel=='4'||list[i].healthLevel=='0'){
      //                 list[i].codeImg = require('../../assets/image/anKang-no.png')
      //             }
      //         }
      //         that.codeList = list
      //         setTimeout(function(){
      //             that.timer5 = setInterval(that.scroll5,1200) // 班组考勤滚动
      //         },1000)
      //     }
      // })
    },
    //获取关键岗位
    getPostList() {
      var that = this
      if (that.groupId == '1506900977511251969') {
        var list = [
          {
            "csSum": 20,
            "name": "李晨阳",
            "personId": "1523507647356022785",
            "label": "建设单位负责人",
            "idcardPhoto": "/wisdom/idcard/20220623/1506900977511251969/1655971565822.jpg"
          },
          {
            "csSum": 21,
            "name": "方勇",
            "personId": "1523506578483785729",
            "label": "监理单位总监",
            "idcardPhoto": "/wisdom/idcard/20220623/1506900977511251969/1655971569814.jpg"
          },
          {
            "csSum": 18,
            "name": "程希",
            "personId": "1523507816801710082",
            "label": "项目经理",
            "idcardPhoto": "/wisdom/idcard/20220623/1506900977511251969/1655971615111.jpg"
          },
          {
            "csSum": 20,
            "name": "杨宗范",
            "personId": "1523507807322583042",
            "label": "技术负责人",
            "idcardPhoto": "/wisdom/idcard/20220623/1506900977511251969/1655971608018.jpg"
          },
          {
            "csSum": 22,
            "name": "陈建好",
            "personId": "1523507807322583042",
            "label": "安全总监",
            "idcardPhoto": "/wisdom/idcard/20220623/1506900977511251969/1655971607856.jpg"
          },
          {
            "csSum": 21,
            "name": "丁建华",
            "personId": "1440117676742414337",
            "label": "生产经理",
            "idcardPhoto": "/wisdom/idcard/20220623/1506900977511251969/1655971615720.jpg"
          }];
        for (var i = 0; i < list.length; i++) {
          list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto != '' ? base.httpCtx + list[i].idcardPhoto : require('../../assets/image/zanwutupian.png')
          let csSum = (parseInt(list[i].csSum) / parseInt(new Date().getDate()) * 100).toFixed(0)
          list[i].csSum = csSum > 100 ? 100 : csSum
        }
        that.psotList = list
        setTimeout(function () {
          that.timer4 = setInterval(that.scroll4, 1200) // 班组考勤滚动
        }, 1000)
      } else if (that.groupId == '1470557328339062785') {
        let list1 = [
          {
            csSum: 8,
            idcardPhoto: "/wisdom/idcard/20220629/1470557328339062785/340103196302192010.jpg",
            label: "监理单位总监工程师",
            name: "田峰",
            personId: "1542048349148901378"
          },
          {
            csSum: 8,
            idcardPhoto: "/wisdom/idcard/20220629/1470557328339062785/370222198003091112.jpg",
            label: "施工单位项目经理",
            name: "孙林荀",
            personId: "1542093483437682689"
          },
        ]
        for (var i = 0; i < list1.length; i++) {
          list1[i].idcardPhoto = list1[i].idcardPhoto && list1[i].idcardPhoto != '' ? base.httpCtx + list1[i].idcardPhoto : require('../../assets/image/zanwutupian.png')
          list1[i].csSum = 100
        }
        that.psotList = list1
      } else {
        myHttp.keyPosition({
          projectId: this.groupId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto != '' ? base.httpCtx + list[i].idcardPhoto : require('../../assets/image/zanwutupian.png')
              list[i].csSum = (parseInt(list[i].csSum) / parseInt(new Date().getDate()) * 100).toFixed(0)
            }
            that.psotList = list
            setTimeout(function () {
              that.timer4 = setInterval(that.scroll4, 1200) // 班组考勤滚动
            }, 1000)
          }
        })
      }

    },
    //合同列表滚动
    scroll1() {

      if (this.tableAgree.length > 6) {
        var that = this
        this.animate = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.tableAgree.push(this.tableAgree[0]);  // 将数组的第一个元素添加到数组的
          this.tableAgree.shift();               //删除数组的第一个元素 attendTeam
          this.animate = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1200)
      } else {
        window.clearInterval(this.timer1)
      }
    },
    //今日采集列表滚动
    scroll2() {
      if (this.cjData.length > 3) {
        var that = this
        this.animate1 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.cjData.push(this.cjData[0]);
          this.cjData.shift();
          this.animate1 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timer2)
      }
    },
    //质安检查列表滚动
    scroll10() {
      if (this.proQsList.length > 7) {
        var that = this
        this.animate10 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.proQsList.push(this.proQsList[0]);
          this.proQsList.shift();
          this.animate10 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timer10)
      }
    },
    //近日入厂施工人员滚动
    scrollA() {
      if (this.TeamsAttendList.length > 7) {
        var that = this
        this.animateA = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.TeamsAttendList.push(this.TeamsAttendList[0]);
          this.TeamsAttendList.shift();
          this.animateA = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timerA)
      }
    },
    scrollB() {
      if (this.DayEducationList.length > 7) {
        var that = this
        this.animateB = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.DayEducationList.push(this.DayEducationList[0]);
          this.DayEducationList.shift();
          this.animateB = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timerB)
      }
    },

    //班组考勤列表滚动
    scroll3() {
      if (this.attendTeam.length > 7) {
        var that = this
        this.animate2 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.attendTeam.push(this.attendTeam[0]);
          this.attendTeam.shift();
          this.animate2 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timer3)
      }
    },
    // 近日教育入厂人员滚动
    scroll7() {
      if (this.attendTeam.length > 7) {
        var that = this
        this.animate2 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.attendTeam.push(this.attendTeam[0]);
          this.attendTeam.shift();
          this.animate2 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timer3)
      }
    },
    //关键岗位
    scroll4() {
      if (this.psotList.length > 3) {
        var that = this
        that.animate4 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理that指向偏移问题，代码也比之前简化了很多
          that.psotList.push(that.psotList[0]);
          that.psotList.shift();
          that.animate4 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        if(that.timer4){
        window.clearInterval(that.timer4)}
      }
    },
       scroll4S() {
          var that = this
      
      if (this.teqinList.length > 3) {
    
      
        that.animate4S = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理that指向偏移问题，代码也比之前简化了很多
          that.teqinList.push(that.teqinList[0]);
          that.teqinList.shift();
          that.animate4S = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(that.timer4S)
      }
    },
    //安康码列表
    scroll5() {
      if (this.codeList.length > 3) {
        var that = this
        this.animate5 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.codeList.push(this.codeList[0]);
          this.codeList.shift();
          this.animate5 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timer5)
      }
    },
    //参建单位
    scroll6() {
      if (this.ents.length > 6) {
        var that = this
        this.animate6 = true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
        setTimeout(() => {      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
          this.ents.push(this.ents[0]);
          this.ents.shift();
          this.animate6 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
        }, 1000)
      } else {
        window.clearInterval(this.timer6)
      }
    },
    //
    setChart1() {
      var data = {
        zz: this.syn.zz || 0,
        wzz: this.syn.wzz || 0,
        lz: this.syn.lz || 0,
        zs: this.syn.zs || 0
      }
      data.zz = data.zz == 0 ? 0.001 : data.zz
      data.wzz = data.wzz == 0 ? 0.001 : data.wzz
      data.lz = data.lz == 0 ? 0.001 : data.lz
      var chart = HighCharts.chart('myChart1', {
        // chart: {
        //     spacing : [40, 0 , 40, 0]
        // },
        subtitle: {
          floating: true,
          verticalAlign: 'middle',
          text: data.zs + '人',
          style: {
            fontSize: 10,
            color: '#7058F8',
          },
          y: 30,
        },
        title: {
          // floating:true,
          text: '人员动态',
          verticalAlign: 'middle',
          style: {
            fontSize: '10px'
          },
          y: 10
        },
        tooltip: {
          pointFormat: '<b>{point.y:.0f}</b>',
          headerFormat: '<span style="font-size: 16px">{series.name}</span><br/><span style="font-size: 16px">{point.key}</span>：'
        },
        colors: ['#228FFE', '#F7B61C', '#F45E23'],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              // formatter:function(){

              //     return this.y==0.001?'0%':this.percentage+' %'
              // },
              format: ' {point.percentage:.1f} %',
              style: {
                fontSize: '10px'
              },
            },
            point: {
              events: {}
            },
          }
        },
        series: [{
          type: 'pie',
          size: '90%',
          innerSize: '70%',
          name: '人数',
          dataLabels: {
            formatter: function () {
              return this.point.name;
            },
            //color: '#ffffff',
            distance: 1,

          },
          data: [
            ['在职', data.zz],
            ['离职', data.lz],
            ['未分配', data.wzz]
          ]
        }]
      });
    },
    //展示第一个3D饼状图片
    showPie3D() {
      var data = {
        paperNum: this.edc.paperNum || 0,
        nopaper: this.edc.nopaper || 0,
      }
      data.paperNum = data.paperNum == 0 ? 0.01 : data.paperNum
      data.nopaper = data.nopaper == 0 ? 0.01 : data.nopaper
      HighCharts.chart('pie1', {
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },

        colors: ['#FF5446', '#FFE0E0'],
        title: {
          text: '',
        },
        tooltip: {
          pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>',
          headerFormat: ''
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
              enabled: true,
              format: '{point.name} <br/>{point.percentage:.1f}%'
              // formatter:function(){
              //     return '<span style="color:#4dd3b9">['+ this.point.name +' '+ Highcharts.numberFormat(this.percentage, 1)+'%]</span>';
              // }
            }
          }
        },
        series: [{
          type: 'pie',
          name: '入职考试',
          size: '100%',
          center: ['50%', '40%'],
          data: [
            ['未考试', data.nopaper],
            ['已考试', data.paperNum],
          ],
          dataLabels: {
            formatter: function () {
              return this.point.name;
            },
            //color: '#ffffff',
            connectorPadding: 1,
            distance: 2,

          },
        }]
      })
    },
    //展示第二个3D饼状图
    showPie3D1() {
      HighCharts.chart('pie2', {
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },

        colors: ['#FFC941', '#FFFBE0'],
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>',
          headerFormat: ''
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
              enabled: true,
              format: '{point.name} <br/> {point.percentage:.1f}%'
              // formatter:function(){
              //     // return '<span style="color:#4dd3b9">['+ this.point.name +' '+ Highcharts.numberFormat(this.percentage, 1)+'%]</span>';
              //     return  '<p style="color:#000000;">'+ this.point.name +'</p><br><p style="color:color:#000000;">'+ (this.percentage).toFixed(1)+'%</p>';
              // },
              // style: {
              //     textOutline: '0px 0px contrast',        //去掉文字白边
              //     fill:'#000000',
              // }
            }
          }
        },
        series: [{
          type: 'pie',
          name: '入职考试',
          size: '100%',
          center: ['50%', '40%'],
          data: [
            ['已接受教育', 77],
            ['未接受教育', 23],
          ],
          dataLabels: {
            formatter: function () {
              return this.point.name;
            },
            // color: '#ffffff',
            distance: 1,

          },
        }]
      })
    },
    //展示柱状图
    showBar() {
      var data = this.ageBar
      HighCharts.chart('bar1', {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        colors: ['#5995FD'],
        xAxis: {
          type: 'category',
          // labels: {
          //     rotation: -45  // 设置轴标签旋转角度
          // },
          title: {
            text: '(单位：岁)',
            align: 'high',
            style: {
              fontSize: '10'
            }
          }
        },
        yAxis: {
          // min: 0,
          title: {
            text: '(单位：人)',
            align: 'high'
          },
        },
        legend: {
          enabled: false
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.0f} 人</b>',
          headerFormat: '{series[0].center[1]}<br/>'
        },
        series: [{
          name: '人数',
          borderRadius: '0',
          maxPointWidth: 15,
          data: [
            ['<=25', data.xy25],
            ['<=30', data.xy30],
            ['<=35', data.xy35],
            ['<=40', data.xy40],
            ['<=45', data.xy45],
            ['<=50', data.xy50],
            ['<=55', data.xy55],
            ['<=60', data.sx60]
          ],
          // dataLabels: {
          //     enabled: true,
          //     rotation: -90,
          //     color: '#FFFFFF',
          //     align: 'right',
          //     format: '{point.y:.1f}', // :.1f 为保留 1 位小数
          //     y: 10
          // }
        }]
      });
    },
    /**字体滚动 */
    // 定时增长数字
    // increaseNumber () {
    //     let self = this
    //     this.timer = setInterval(() => {
    //         var num =  self.getRandomNumber()
    //         var len = num.toString().length
    //         self.numLen1 = []
    //         for(var i=0;i<len;i++){
    //             self.numLen1.push('0')
    //         }
    //         setTimeout(function(){self.setNumberTransform(num)},1000)

    //     }, 3000)
    // },
    // 设置每一位数字的偏移
    setNumberTransform(num, items) {
      let numberItems = items
      let numberArr = (num + '').split('')
      for (let index = 0; index < numberItems.length; index++) {
        let elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
    getRandomNumber() {
      var val = Math.ceil(Math.random() * 1000);
      return val
    },
    //跳转去安康码统计页面
    // toAnKangTotal(){
    //     this.$router.push({path:'/anKang'})
    // },
    intoReal(status) {
      this.$router.push({path: '/realName/' + status,})

    },
    // 今日入厂人员统计
    async getAttendNew() {
      const data = await myHttp.getAttendNew({
        projectId: this.groupId,
        sortings: 1,
        date: util.myTime.getCurTime()
      })
      if (data.data.code == 200) {
        const that = this
        const list = data.data.data.list
        this.TeamsAttendList = list
        setTimeout(function () {
          that.timerA = setInterval(that.scrollA, 1300) // 班组考勤滚动
        }, 500)
      }
    },
    // 获取当日教育入厂人员
    async selectDayEducation() {
      const data = await myHttp.selectDayEducation({
        projectId: this.groupId
      })
      if (data.data.code == 200) {
        const list = data.data.data.DayEducation
        this.DayEducationList = list


        setTimeout(function () {
          this.timerB = setInterval(this.scrollB, 1300) // 班组考勤滚动
        }, 500)
      }
    }
  }
}
</script>
<style scoped>
.home-box {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1vh 0;
  overflow: auto;
}

.first-line {
  width: 100%;
  height: 20vh;
  position: relative;
  background: #fff;
  border-radius: 0.5vh;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

.first-head {
  width: 100%;
  height: 30%;
  position: relative;
  display: flex;
  padding: 0 1.5vh;
}

.first-head p {
  width: 33%;
  height: 100%;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  font-size: 0.9vw;
}

.first-head .crile {
  width: 1.5vh;
  height: 1.5vh;
  display: inline-block;
  border-radius: 50%;
  margin-right: 1vw;
}

.first-body {
  width: 100%;
  height: 70%;
  position: relative;
  display: flex;
  padding: 0 1.5vh;
  /* align-content: center;
        align-items: center;
        font-size: 1.5vw; */
}

.first-body-item {
  width: 33%;
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* justify-items: center; */
  -webkit-justify-items: center;
  align-content: center;
  align-items: center;
}

.first-body-item .num {
  font-size: 3vw;
  width: 100%;
  position: relative;
  /* text-shadow:0 0 6px #fff, 0 0 8px #4D73C2; */
  -webkit-text-stroke: 3px #fff;
  /* -webkit-text-stroke-width: 3px; */
  -webkit-text-stroke-color: white;
  /* text-stroke: 3px #fff; */
  text-shadow: /* #fff 4px 0 0,#fff 0 4px 0,#fff -4px 0 0,#fff 0 -4px 0, */ /* #4D73C2 5px 0 0,#4D73C2 0 5px 0,#4D73C2 -5px 0 0,#4D73C2 0 -5px 0, */ #4D73C2 5px 0 6px, #4D73C2 0 5px 6px, #4D73C2 -5px 0 6px, #4D73C2 0 -5px 6px;

  /* text-shadow: 3px 0 0 #fff, 0 3px 0 #fff, -3px 0 0 #fff, 0 -3px 0 #fff,
                     0 0 6px #1E369A; */
  /* letter-spacing: 0.5vw; */
  /* font-family: auto; */
  font-weight: 600;
  display: flex;
  justify-content: center;
}

.first-body .echart1 {
  position: absolute;
  top: -15%;
  left: 0;
  width: 50%;
  height: 120%;
}

.first-gress {
  /* width: 100%;
        height: 100%;
        position: relative;
        padding-left: 50%; */
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
}

.first-gress-con {
  width: 10vw;
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  top: -0.3vh;
}

.first-gress-con p {
  width: 100%;
  /* padding: 0 1vh; */
  position: relative;
  text-align: left;
  display: flex;
  align-items: flex-end;
  align-content: flex-end;
}

.progressH {
  width: 100%;
  /* padding: 0 1vh; */
  position: relative;
  height: 1vh;
  border: 1px solid #7FD7E0;
}

.first-gress-con .inner {
  height: 100%;
  top: 0;
  left: 0;
  display: inline-block;
  position: relative;
}

.second-top {
  margin-top: 1vh;
}

.second-line {
  width: 100%;
  height: 33vh;
  position: relative;
  background: #fff;
  border-radius: 0.5vh;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  /* margin-top:1vh; */
}

.second-head {
  width: 100%;
  height: 15%;
  position: relative;
  display: flex;
  padding: 0 1.5vh;
}

.second-head p {
  width: 33%;
  height: 100%;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  font-size: 0.9vw;
}

.second-head .crile {
  width: 1.5vh;
  height: 1.5vh;
  display: inline-block;
  border-radius: 50%;
  margin-right: 1vw;
}

.second-total {
  width: 100%;
  height: 4vh;
  position: relative;
  display: flex;
  padding: 0 1.5vh;
  justify-content: space-around;
}

.second-body {
  width: 100%;
  height: 80%;
  position: relative;
  display: flex;
  padding: 0 1.5vh;
  flex-wrap: wrap;
  overflow: hidden;
}

.second-total p {
  font-size: 0.8vw;
}

/* .second-body .el-table__body{
        position: relative;
        top: 0px;
    } */
.anim {
  transition: all 1s;
  margin-top: -4vh;
}

.anim1 {
  transition: all 1s;
  margin-top: -7vh;
}

.anim2 {
  transition: all 1s;
  margin-top: -7vh;
}

.table-head {
  width: 100%;
  height: 3vh;
  position: relative;
  display: flex;
}

.table-head p {
  width: 33%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
}

.table-head-list {
  width: 100%;
  height: calc(100% - 3.1vh);
  position: relative;
  overflow: hidden;
}

.table-li {
  width: 100%;
  height: 4vh;
  position: relative;
  display: flex;
}

.table-li p {
  width: 33%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
}

.second-body ul {
  width: 100%;
  height: 100%;
  position: relative;
}

.hight-pie1 {
  width: 50%;
  height: 100%;
  position: relative;
}

.pie-box {
  width: 100%;
  height: 100%;
  position: relative;
}

.second-footer {
  width: 100%;
  height: 20%;
  position: relative;
  display: flex;
  padding: 0 1.5vh;
  justify-content: space-around;
}

.second-footer .total-p {
  font-size: 1.5vh;
}

.table-li-team p {
  width: 25%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
}

.hight-Bar {
  width: 100%;
  height: 100%;
  position: relative;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group-item {
  cursor: move;
  padding: 0.5vh 1vh;
}

.no-move {
  cursor: auto;
}

/* 数字滚动 */
.number-item {
  width: 2.6vw;
  height: 6vh;
}

.number-item span {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  width: 100%;
  height: 100%;
  writing-mode: vertical-rl;
  font-size: 15px;
  writing-mode: tb-rl;
  text-align: center;
  line-height: 32px;
  display: inline-block;
  /* -webkit-text-orientation: upright; */
  /* -ms-text-orientation: upright; */
  text-orientation: upright;
  overflow: hidden;
  /* -webkit-transform:rotate(-90deg);
        -ms-transform:rotate(-90deg);
        -moz-transform:rotate(-90deg);
        -o-transform: rotate(-90deg); */
  white-space: nowrap;
  display: block;


}

.number-item i {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  transition: transform 1s ease-in-out;
  letter-spacing: 10px;
  font-size: 2.9vw;
}

.ieLft {
  left: 430% !important;
}

.num-box {
  width: 100%;
  height: 7vh;
  position: relative;
  padding: 0 1vh;
  display: flex;
}

.num-box-item {
  width: 33%;
  height: 100%;
  padding: 0.5vh;
  position: relative;
  /* cursor: pointer; */
}

.num-box-item .txt {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  padding: 1vh 0;
}
</style>
<style>
.highcharts-credits {
  display: none;
}
</style>